var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { makeObservable, override } from 'mobx';
import { MenubarPathStepNeighbour } from './MenubarPathStepNeighbour';
export class MenubarPathStepNeighbourTopic extends MenubarPathStepNeighbour {
    constructor(init) {
        super(init);
        makeObservable(this);
    }
    get topic() {
        return this.app.model.stream.topic[this.locationData.pathURI];
    }
    get solidTopic() {
        return this.topic;
    }
    get location() {
        return this.topic;
    }
    goToLocation(e) {
        e.preventDefault();
        this.step.isNeighbourMenuOpen = false;
        window.location.replace(this.hrefUrl);
    }
}
__decorate([
    override
], MenubarPathStepNeighbourTopic.prototype, "goToLocation", null);
